import { NpIcon, NpIconName } from "src/components/np-design/components/NpIcon"
import { CouponData } from "src/data/product-details/types"
import { formatPriceShort } from "src/utilities/price"

export type DiscountHeaderProps = {
  discount: number | undefined
  regularPrice: number | undefined
  coupon: CouponData | undefined
  available: boolean | undefined
}

export const DiscountHeader = ({ discount, coupon, regularPrice, available }: DiscountHeaderProps) => {
  if (!available) {
    return (
      <div className="flex h-14 items-center justify-center text-base leading-tight">🚫 Derzeit nicht verfügbar</div>
    )
  }

  if (!discount) {
    // lg is when ProductList columns go from 1 to 2
    return <div className="lg:h-14" />
  }

  const type = coupon ? "coupon" : "sale"
  const iconName: NpIconName = coupon ? "percent" : "sell"
  const heading = coupon ? "Aktion" : "Reduziert"
  const amount = coupon ? coupon.text : formatPriceShort(discount)
  const text = (
    <>
      Spare heute {type === "coupon" && regularPrice ? <u>zusätzlich</u> : null} {amount}
    </>
  )

  return (
    <div className="text-elvent-discount-contrast flex h-14 items-center justify-center gap-4 border-t border-transparent pr-4 pl-2 text-base leading-tight">
      <div className="flex items-center whitespace-nowrap uppercase">
        <NpIcon name={iconName} />
        {heading}
      </div>

      <div>{text}</div>
    </div>
  )
}
